export const getCreatedStore= state => state.paymentR.createdStore;
export const getStatus = state => state.paymentR.status;
export const getError = state => state.paymentR.error;
export const getLoading = state => state.paymentR.loading;
export const getCurrentDaySale = state => state.paymentR.currentDaySale;
export const getFiscalData = state => state.paymentR.fiscalData;
export const getFiscalError = state => state.paymentR.fiscalError;
